import { StrategyBooleanFields, StrategyNameField, StrategyTypeField } from '../shared/StrategyFields'

export const UpdateStrategyFormFields = ({
  strategyTypes,
  disabled,
}: {
  strategyTypes: string[]
  disabled: boolean
}) => (
  <fieldset disabled={disabled} className="space-y-4 min-w-0">
    <StrategyNameField />
    <StrategyTypeField strategyTypes={strategyTypes} disabled={disabled} />
    <StrategyBooleanFields disabled={disabled} />
  </fieldset>
)
